<template>
  <main class="importMobile container-fluid mf_container pb_50 mb_50">
    <div v-show="is_ready">
      <h4 class="text-green mt_22">業績換算</h4>
      <div class="mt_17"><strong>選擇要換算的建議商品</strong></div>
      <OperateContractItemTD
        @isReady="updateReady"
        v-if="!isLoading"
        selectedMode="checkbox"
        :contractData="proposal"
        @updateMCProdList="handleUpdate"
      ></OperateContractItemTD>
      <FixedBottom>
        <template slot="@function">
          <div class="d-flex justify-content-end mr_15">
            <router-link
              class="btn btn-default px_5 mr_10"
              to="/mf/query/queryDetail"
              >查詢其他建議書</router-link
            >
            <button
              @click="performaceProduct()"
              class="btn btn-primary px_5 mr_10"
              type="button"
              :disabled="!is_selected || waiting"
            >
              開始換算
            </button>
          </div>
        </template>
      </FixedBottom>
    </div>
    <MfLoading :open="!is_ready" content="資料讀取中..." />
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import mf_Mixin from "@/desktop/views/mf/mixin";
import MfLoading from "@/desktop/views/mf/components/MfLoading";
import FixedBottom from "@/desktop/views/mf/components/fixedBotton";
import OperateContractItemTD from "@/desktop/views/mf/components/OperateContractItem_TD.vue";

export default {
  mixins: [mf_Mixin],
  components: { MfLoading, OperateContractItemTD, FixedBottom },
  data() {
    return {
      proposal: {},
      proposalListScope: [],
      waiting: false,
      no_mi_list: [],
      isLoading: true,
      is_selected: true,
      is_ready: false,
      is_performance: false,
    };
  },
  computed: {
    ...mapGetters(["UserInfo", "MfViewing", "UnCheckedMc_idx"]),
  },
  async created() {
    if (!this.MfViewing.prod_idx) {
      return this.$router.push("/mf/performace");
    }
    this.updateClickDate();
    let res_Data = await this.$mfAPI.MFA0_1000__queryProposalDetailList({
      agent_id: this.$store.state.userInfo.id,
      insured_id: "",
      prod_idx: this.MfViewing.saveData.prod_idx,
    });
    this.proposal = res_Data.proposal[0];
    this.isLoading = false;
    this.proposalListScope = this.proposal.mc_prod_list;
    // < ---- 建議書加入排序 ---- >
    this.proposalListScope.forEach((item, index) => {
      item.order = index + 1;
    });
  },
  methods: {
    async performaceProduct() {
      this.waiting = true;
      // < ---- 已勾選商品 ---- >
      let checkedProduct = this.proposalListScope.filter((item) => {
        return item.is_checked;
      });

      if (checkedProduct.length < 1) {
        this.$toast.info({ title: `請先勾選建議!` });
        this.waiting = false;
      }
      // < ---- 已勾選商品資料整理 ---- >
      this.proposal.NO = this.MfViewing.NO;
      this.proposal.mc_prod_list = checkedProduct;
      this.$store.commit("update_proposalList", {
        ...this.proposal,
      });

      // < ---- 未勾選商品 item mc_idx 存進 store---- >
      const unCheckedList = [];
      this.proposalListScope.filter((item) => {
        if (!item.is_checked) {
          unCheckedList.push(item.mc_idx);
        }
      });

      this.$store.commit("update_unChecked_mc_idx", {
        data: unCheckedList,
      });
      this.is_ready = false;
      this.$router.push("/mf/performace/result");
    },

    handleUpdate(mc_prod_list) {
      this.proposalListScope = mc_prod_list;
      this.is_selected = false;
      this.proposalListScope.forEach((mc) => {
        if (mc.is_checked) {
          this.is_selected = true;
          return;
        }
        mc.sc_prod_list.forEach((sc) => {
          if (sc.is_checked) {
            this.is_selected = true;
          }
        });
      });
    },
    updateReady() {
      this.is_ready = true;
      // < ---- 呈現未勾選業績換算商品 ---- >
      this.proposal.mc_prod_list.forEach((item) => {
        if (this.UnCheckedMc_idx.includes(item.mc_idx)) {
          item.is_checked = false;
        } else {
          item.is_checked = true;
        }
      });

      // < ---- 清掉store 裡未勾選商品---- >
      this.$store.commit("update_unChecked_mc_idx", {
        data: [],
      });
    },
    goBack() {
      // < ---- 清掉store 裡未勾選商品---- >
      this.$store.commit("update_unChecked_mc_idx", {
        data: [],
      });
    },
  },
};
</script>
<style lang="scss">
.importMobile {
  color: #323a45;
  @media (min-width: 1025px) {
    width: 100%;
    max-width: 1280px;
  }
  &__proposalList {
    padding: 20px 0;
    &__item {
      display: flex;
      align-items: flex-start;
      border-bottom: solid 1px #e0e1e3;
    }
    .checkbox input + label:before {
      margin: 0;
    }
  }
}
</style>
